import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { AtomSpinner } from 'epic-spinners'
import VueKinesis from 'vue-kinesis'
import TrendChart from "vue-trend-chart";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


Vue.prototype.$liff = window.liff
Vue.config.productionTip = false
Vue.use(VueKinesis)
Vue.use(TrendChart);
Vue.component('atom-spinner', AtomSpinner);
Vue.component('loading', Loading);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
